import { Button } from "@/components/ui/button";
import { Typography } from "@/components/ui/typography";

interface MatchMaterialsQuestionProps {
  onYes: () => void;
  onNo: () => void;
}

export function MatchMaterialsQuestion({ onYes, onNo }: MatchMaterialsQuestionProps) {
  return (
    <div className="flex flex-col gap-2">
      <Typography variant="text-xl" weight="semibold" className="text-center">
        Do you want to match the strongback materials to the enclosure material?
      </Typography>
      <div className="flex justify-center gap-2">
        <Button variant="outline" onClick={onNo}>
          No
        </Button>
        <Button onClick={onYes}>Yes</Button>
      </div>
    </div>
  );
}
